import { defineComponent as _defineComponent } from 'vue'
import { PropType } from 'vue'
import { computed } from '@nuxtjs/composition-api'
import { IOrderElement } from './../model/types'
import { useDiffCheckModel } from '@features/diff-check'
import { useThemeModel } from '@entities/theme'
import { useOrderModel } from '@entities/order'
import { useMetaModel } from '@entities/meta'


export default /*#__PURE__*/_defineComponent({
  __name: 'OrderItem',
  props: {
  data: {
    type: Object as PropType<IOrderElement>,
    required: true,
    default: () => ({
      price: 10000,
      name: 'Суп',
      diffCheck: false,
      modifiers: [
        {
          name: 'Модификатор'
        }
      ]
    })
  },
  currencyIcon: {
    type: String as PropType<string>,
    required: false,
    default: ''
  }
},
  emits: ['checkPosition'],
  setup(__props, { emit }) {

const props = __props

const diffCheckModel = useDiffCheckModel()
const themeModel = useThemeModel()
const orderModel = useOrderModel()
const metaModel = useMetaModel()





const checkPosition = async () => {
  if (!diffCheckModel.status || statusOrderItem.value === 'payed') {
    return
  }
  if (!paymentCheck.value && statusOrderItem.value !== 'loading') {
    orderModel.loadingOrderElement(props.data.id)
    const guest = await sessionStorage.getItem('guest')
    emit('checkPosition', {
      id: props.data.id.toString(),
      status: props.data.selected_guest_id === metaModel.guest,
      guest: guest ? parseInt(guest) : null
    })
  }
}

const classOld = computed(() => {
  return hasDifferentPrice.value && diffCheckModel.status && themeModel.theme !== 'Novikov'
})

const classNovikovOld = computed(() => {
  return themeModel.theme === 'Novikov' && hasDifferentPrice && diffCheckModel.status
})

const hasDifferentPrice = computed(() => {
  return props.data.finalPrice !== props.data.price
})

// Получаем кол-во неоплаченных позиций
const hasCheckboxEnable = computed(() => {
  return (
    orderModel.orderElements.filter(
      e => e.status === 'NOT_PAID' || !e.loading
    ).length > 1
  )
})

const paymentCheck = computed(() => {
  if (props.data.selected_guest_id) {
    return props.data.selected_guest_id !== metaModel.guest
  }
  return false
})

const statusOrderItem = computed(() => {
  if (props.data.status === 'PAID') {
    return 'payed'
  }
  if (props.data.loading) {
    return 'loading'
  }
  if (props.data.selected_guest_id === metaModel.guest) {
    return 'not pay'
  }
  if (props.data.selected_guest_id && props.data.status === 'NOT_PAID') {
    return 'paying'
  }
  return 'not pay'
})

const showStatus = computed(() => {
  const len = orderModel.orderElements.length > 1
  return (len && props.data.status === 'PAID') ||
    (len && diffCheckModel.status) ||
      (len && props.data.selected_guest_id && props.data.status === 'NOT_PAID' && props.data.selected_guest_id !== metaModel.guest)
})

const statusOrderItemAutotests = computed(() => {
  return statusOrderItem.value === 'payed'
    ? 'paidDishes'
    : statusOrderItem.value === 'loading'
      ? 'processDishes'
      : statusOrderItem.value === 'not pay' && diffCheckModel.status
        ? 'nonPaidDishes'
        : statusOrderItem.value === 'paying'
          ? 'disabledDishes'
          : ''
})

const statusOrderItemText = computed(() => {
  return statusOrderItem.value === 'payed'
    ? 'Оплачено'
    : statusOrderItem.value === 'loading'
      ? 'Подождите'
      : statusOrderItem.value === 'not pay' && diffCheckModel.status
        ? 'Не оплачено'
        : statusOrderItem.value === 'paying'
          ? 'Оплачивается другим гостем'
          : ''
})

return { __sfc: true,diffCheckModel, themeModel, orderModel, metaModel, emit, props, checkPosition, classOld, classNovikovOld, hasDifferentPrice, hasCheckboxEnable, paymentCheck, statusOrderItem, showStatus, statusOrderItemAutotests, statusOrderItemText }
}

})